<generic-modal #qrScanHistoryList>
	<ng-template #modalHeading>
		<div class="header-container">
			<div class="name-container">
				<span>QR Scans</span>
			</div>
			<button mat-button (click)="close()">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</ng-template>
	<ng-template #modalBody let-data="binderQRScanHistory">
		<div class="main-container">
			<div class="empty-message-container" *ngIf="!binderQRScanHistory?.length">There are no past QR Scans!</div>
	
			<div class="item-container" *ngFor="let qrScan of binderQRScanHistory">
				<div class="username-item">
					<span class="scan-item" *ngIf="qrScan.userName">
						{{qrScan.userName}}
					</span>
				</div>
				<div class="date-item">
					<div class="requested-on">
						<span class="scan-item" *ngIf="qrScan?.qrRequestedOn">
							<span class="label">Requested on: </span>
							{{moment(qrScan.qrRequestedOn).format('MM/DD/YYYY hh:mm A')}}
						</span>
					</div>
					<div class="confirmed-on">
						<span class="scan-item confirmed" *ngIf="qrScan?.qrConfirmedOn">
							<span class="label">Confirmed on: </span>
							{{ moment(qrScan.qrConfirmedOn).format('MM/DD/YYYY hh:mm A')}}
						</span>
						<span class="scan-item not-confirmed" *ngIf="!qrScan?.qrConfirmedOn">
							not confirmed
						</span>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
</generic-modal>
